"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rand_1 = require("../tools/rand");
var types_1 = require("../data/types");
var organism_1 = __importDefault(require("../organism"));
var delay_1 = __importDefault(require("../delay"));
var config_1 = __importDefault(require("../../config"));
var names_1 = require("../data/names");
var resources_1 = __importDefault(require("../resources"));
var Craefter = /** @class */ (function (_super) {
    __extends(Craefter, _super);
    function Craefter(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.type, type = _c === void 0 ? types_1.Unknown : _c, _d = _b.name, name = _d === void 0 ? rand_1.getRandomArrayItem({
            array: names_1.FirstNames
        }) + " " + rand_1.getRandomArrayItem({
            array: names_1.SurNames
        }) : _d, _e = _b.delay, delay = _e === void 0 ? config_1.default.initialCraefterDelay : _e, _f = _b.str, str = _f === void 0 ? 0 : _f, _g = _b.int, int = _g === void 0 ? 0 : _g, _h = _b.dex, dex = _h === void 0 ? 0 : _h, _j = _b.luk, luk = _j === void 0 ? 0 : _j, _k = _b.sta, sta = _k === void 0 ? config_1.default.craefterInitialSta : _k;
        var _this = _super.call(this, {
            name: name,
            sta: sta
        }) || this;
        _this.isCraefting = false;
        _this.itemId = null;
        _this.onDoneCreating = null;
        _this.delay = new delay_1.default({
            delayInSeconds: delay,
            onDelayExpired: function () {
                if (_this.onDoneCreating) {
                    _this.onDoneCreating(
                    // todo evaluate exp properly
                    5);
                }
            }
        });
        _this.id = rand_1.getRandomId();
        _this.type = type;
        _this.name = name;
        _this.str = str;
        _this.int = int;
        _this.dex = dex;
        _this.luk = luk;
        return _this;
    }
    Craefter.hydrate = function (craefter, obj) {
        craefter.delay = delay_1.default.hydrate(obj.delay);
    };
    Craefter.prototype.tick = function (tick) {
        if (this.staCurrent < this.staMax) {
            // todo calculate some creafter parameters in
            this.staCurrent += 0.10;
        }
    };
    Craefter.calculateMaterialImpact = function (material) {
        return ((material ? material : 0.1) / 100) * 80;
    };
    Craefter.prototype.evaluateItemType = function (ratios, highestResource) {
        // stub please override
    };
    Craefter.prototype.evaluateItem = function (_a
    // @ts-ignore
    ) {
        var resources = (_a === void 0 ? {
            resources: new resources_1.default()
        } : _a).resources;
        // stub please override
    };
    Craefter.prototype.craeft = function (_a) {
        var resources = (_a === void 0 ? {
            resources: new resources_1.default()
        } : _a).resources;
        // stub please override
        this.isCraefting = true;
        // todo include resource heaviness / complexity
        this.exhaust(1);
    };
    Craefter.prototype.finishCraefting = function (exp) {
        this.isCraefting = false;
        this.itemId = null;
        // todo inlcude resource heaviness / complexity
        this.addExp(exp);
    };
    Craefter.prototype.evaluateSlot = function (type) {
    };
    Craefter.prototype.exhaust = function (sta) {
        _super.prototype.exhaust.call(this, sta);
        if (Math.floor(this.staCurrent) === 0) {
            this.dead = true;
        }
    };
    return Craefter;
}(organism_1.default));
exports.default = Craefter;
